/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { PRODUCT_NAME } from "../../constants/messages"
import { logoContainerStyle, imgLogo } from "./styles"
import logoPath from "../../assets/images/header-logo.svg"

export const Logo = (props) => {
  const { size } = props
  return (
    <div className="logo-container" css={logoContainerStyle(size)}>
      <img src={logoPath} alt="logo" className="logo" css={imgLogo(size)} />
      <span>{PRODUCT_NAME}</span>
    </div>
  )
}
Logo.propTypes = {
  /** The type of the logo */
  size: PropTypes.oneOf(["large", "small"]),
}

Logo.defaultProps = {
  size: "large",
}
